<template>
    <div class="products">
        <div v-if="loading" class="loading"></div>
        <div class="container">
            <div v-if="products.length <= 0"><h4>Товаров не найдено </h4></div>

            <table v-else class="table">
                <thead class="thead">
                <tr>
                    <td></td>
                    <td>Код</td>
                    <td>Наименование</td>
                    <td>Остаток</td>
                    <td class="text-center">Цена тг</td>
                    <td class="text-center">Заказ (колич.)</td>
                    <td class="text-center">Итог</td>
                </tr>
                </thead>

                <tbody class="tbody">

                <product-tr
                        v-for="(product) in products"
                        :product="product"
                        :key="product.id"
                        :waitingIcon=false
                        @searchChange="searchChange($event)"
                        :itemDelete="true"
                ></product-tr>

                </tbody>
            </table>

            <div class="price-information">
                <div class="right">
                    <div class="info-group">
                        <span class="name">Итог:</span> <span class="value">{{ getTotalPrice | chunk(getTotalPrice)}} тг.</span>
                    </div>
                    <div class="info-group">
                        <span class="name">Позиций: </span><span class="value">{{ getProductsAmount }}</span>
                    </div>
                </div>
            </div>

            <div class="search-products" v-click-outside="hideSeachedProducts">
                <div class="cont">
                    <div class="form-group">
                        <input type="text" v-model="search_products" placeholder="Название продукта">
                        <button @click="searchProducts()" class="btn" type="button">Поиск</button>
                    </div>

                    <table v-if="searched_products != null && searched_products.length > 0" class="table table-hover">
                        <thead class="thead">
                            <tr>
                                <td></td>
                                <td>Код</td>
                                <td>Наименование</td>
                                <td>Остаток</td>
                                <td class="text-center">Цена тг</td>
                                <td class="text-center">Заказ (колич.)</td>
                                <td class="text-center">Итог</td>
                            </tr>
                        </thead>

                        <tbody class="tbody">
                        <product-tr
                                v-for="(product) in searched_products"
                                :product="product"
                                :key="product.id"
                                :waitingIcon=false
                        ></product-tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="basket-information" v-if="products !== null">
                <div class="left">
                    <div class="inf">
                        <strong>Уважаемые партнеры!</strong><br>
                        В случае изменения банковских реквизитов либо контактных данных компании, просим сообщить об этом своему закрепленному менеджеру либо написать нам на электронный адрес: <strong>info@alfastar.kz</strong>.<br>
                        Вы также можете разместить необходимую информацию в поле «Комментарии» мы обязательно примем к сведению.
                    </div>

                    <div class="user-info">
                        <div class="info-group info-group-fio">
                            <span class="name">ФИО:</span><span class="value">{{ this.$auth.user().name }}</span>
                        </div>

                        <div class="info-group">
                            <span class="name">Компания:</span><span
                                class="value">{{ this.$auth.user().company }}</span>
                        </div>

                        <div class="info-group">
                            <span class="name">БИН</span><span class="value">{{ this.$auth.user().bin }}</span>
                        </div>

                        <div class="info-group">
                            <span class="name">E-mail:</span><span class="value">{{ this.$auth.user().email }}</span>
                        </div>

                        <div class="info-group">
                            <span class="name">Телефон:</span><span class="value">{{ this.$auth.user().phone }}</span>
                        </div>
                    </div>
                </div>

                <div class="right">
                    <form @submit="basket">
                        <div class="form-group">
                            <label for="comment">Комментарии</label>
                            <textarea ref="comment" id="comment" rows="10"></textarea>
                        </div>

                        <div class="form-group form-group-error">
                            <span>
                                <b>Внимание!</b><br>
                                Обращаем ваше внимание на то, что возможно некоторые категории товаров находятся в резерве и реальный остаток больше, чем указан на портале. <br>
                                Для получения дополнительной информации вы можете обратится к вашему персональному менеджеру.
                            </span>
                        </div>

                        <div class="form-group form-group-warning">
                            Нажимая «Отправить» вы подтверждаете правильность указанных данных и выбранных товаров. Счет на оплату формируется и высылается на e-mail: {{ this.$auth.user().email }} автоматически. Резерв на выбранный товар действует в течении одного дня.
                        </div>

                        <div class="row">
                            <button type="submit" class="btn btn-main" style="margin-left: 15px" :disabled="products.length <= 0">Отправить</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductTr from "./order/Product";
    import {mapActions, mapGetters} from "vuex";

    const swal = require('sweetalert2');

    import Vue from 'vue'

    Vue.directive('click-outside',{
        bind: function (el, binding, vnode) {
            el.eventSetDrag = function () {
                el.setAttribute('data-dragging', 'yes');
            }
            el.eventClearDrag = function () {
                el.removeAttribute('data-dragging');
            }
            el.eventOnClick = function (event) {
                var dragging = el.getAttribute('data-dragging');
                // Check that the click was outside the el and its children, and wasn't a drag
                if (!(el == event.target || el.contains(event.target)) && !dragging) {
                    // call method provided in attribute value
                    vnode.context[binding.expression](event);
                }
            };
            document.addEventListener('touchstart', el.eventClearDrag);
            document.addEventListener('touchmove', el.eventSetDrag);
            document.addEventListener('click', el.eventOnClick);
            document.addEventListener('touchend', el.eventOnClick);
        }, unbind: function (el) {
            document.removeEventListener('touchstart', el.eventClearDrag);
            document.removeEventListener('touchmove', el.eventSetDrag);
            document.removeEventListener('click', el.eventOnClick);
            document.removeEventListener('touchend', el.eventOnClick);
            el.removeAttribute('data-dragging');
        },
    });

    export default {
        data() {
            return {
                products: null,
                selected_manager: this.$auth.user().manager_id,
                searched_products: null,
                search_products: null,
                loading: false,
            }
        },

        mounted() {
            this.products = this.storeInformations;
        },

        computed: {
            ...mapGetters([
                'storeInformations',
                'getProductsAmount',
                'getTotalPrice',
            ]),
        },

        methods: {

            ...mapActions({
                getProductsWithBasketAction: 'pushProductsWithBasket',
            }),

            searchChange(asd){
                if (this.searched_products !== null && this.searched_products.length !== 0){
                    this.searched_products = null;
                }
            },

            sweetSuccess() {
                swal.fire({
                    icon: 'success',
                    title: 'Success',
                    showConfirmButton: false,
                    timer: 1500
                });
            },

            basket(e) {
                e.preventDefault();
                let currentObj = this.$refs;
                this.loading = true;
                let app = this;
                this.axios.post(this.axios.defaults.baseURL + 'order-basket', {
                    comment: currentObj.comment.value,
                    products: this.products,
                    total_price: this.getTotalPrice
                })
                    .then(function (response) {
                        console.log(response.data)
                        if(response.data.message === "success"){
                            swal.fire({
                                icon: 'success',
                                title: 'Ваш заказ успешно оформлен',
                                showConfirmButton: false,
                                timer: 1500
                            });

                            app.$store.commit('RESET_STORE_PRODUCTS')
                            setTimeout(function () {
                                app.$router.push({name: 'HistorySingle', params: {order_number: response.data.order_number}})
                            }, 1000)
                        }
                    })

                    .catch(function (error) {
                        console.log(error)
                        swal.fire({
                            icon: 'error',
                            title: 'Произошла ошибка. Повторите попытку позже.',
                            showConfirmButton: false,
                            timer: 1500
                        })
                    });
            },

            searchProducts() {
                if (this.search_products != null && this.search_products.length >= 3) {
                    this.axios
                        .get(this.axios.defaults.baseURL + 'search-products', {
                            params: {
                                'search_products': this.search_products
                            }
                        })
                        .then(response => {
                            this.getProductsWithBasketAction({ products: response.data.products }).then(response => {
                                this.searched_products = response
                            })
                            // console.log(this.searched_products)
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            },

            hideSeachedProducts(){
                this.searched_products = null;
                this.search_products = null;
            }
        },

        filters: {
            chunk: function (x) {
                var parts = x.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                return parts.join(".");
            },
        },

        components: {
            ProductTr,
        }
    }
</script>

<style lang="scss">
    @import '~sweetalert2/src/variables';
    @import '~sweetalert2/src/sweetalert2';


    .price-information {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        /*justify-content: space-between;*/
        margin-top: 50px;
        .right {
            .info-group {
                font-size: 20px;
                margin-bottom: 25px;
                text-align: right;

                .name {
                    font-family: "Roboto-Bold";
                }
            }
        }
    }

    .search-products {
        .cont {
            .form-group {
                display: flex;
                align-items: center;

                input {
                    width: 100%;
                    border: 1px solid #bbbbbb;
                    border-radius: 5px 0 0 5px;
                    padding: 10px;
                    font-size: 16px;
                }

                .btn {
                    background-color: #5cb85c;
                    border: 1px solid #5cb85c;
                    border-radius: 0 5px 5px 0;
                    padding: 7.5px 15px;
                    color: #fff;
                    font-size: 16px;
                    cursor: pointer;
                    transition: 200ms;


                    &:hover {
                        box-shadow: 1px 0 0 1px rgba(#5cb85c, .4);
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/app/pages/Basket.vue